export const certificado = {
  meus: {
    title: 'My Certificates',
    description: 'Certificates issued for the tracks and courses you have completed.',
    empty: {
      title: 'You don’t have any certificates yet.',
      description: 'Complete a track or course to earn yours.',
    },
    emitidoEm: 'Issued on',
    baixarPdf: 'Download PDF',
    verificar: 'Verify',
    pdf: {
      sucesso: 'Download started.',
      erro: 'Could not generate the PDF right now.',
    },
  },
  tipo: {
    trilha: 'Track',
    curso: 'Course',
  },
  verify: {
    loading: 'Verifying certificate...',
    valido: {
      title: 'Valid certificate',
      subtitle: 'Authenticity confirmed by NT Academy.',
      concluiu: 'completed',
      concluidoEm: 'Completed on',
      emitidoEm: 'Issued on',
      codigo: 'Code',
    },
    naoEncontrado: {
      title: 'Certificate not found',
      description: 'There is no valid certificate for this address.',
      hint: 'Check the link or the code provided.',
    },
    erro: {
      title: 'Could not verify right now.',
      description: 'Please try again shortly.',
    },
  },
} as const;
